export default __webpack_public_path__ + "static/media/truck-background-desktop.8a105567.png";